import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import PublicSite from '../pages/PublicSite';
import { portalUrl } from '../lib/hostSite';

/** Any other path on the website host belongs to the app: send it to the portal. */
function ToPortal({ portalOrigin }) {
  const location = useLocation();
  useEffect(() => {
    if (portalOrigin)
      window.location.replace(portalUrl(portalOrigin, location.pathname, location.search));
  }, [portalOrigin, location.pathname, location.search]);
  return (
    <p className="p-8 text-dcon-ink-muted" role="status">
      Opening the member portal.
    </p>
  );
}

/**
 * The whole app on an organization's website host (docs/Decisions.md D60
 * item 4): its template site at `/` and `/<page>`, nothing else.
 */
export default function HostedSite({ slug, portalOrigin }) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicSite slug={slug} basePath="" appOrigin={portalOrigin} />} />
        <Route
          path="/:page"
          element={<PublicSite slug={slug} basePath="" appOrigin={portalOrigin} />}
        />
        <Route path="*" element={<ToPortal portalOrigin={portalOrigin} />} />
      </Routes>
    </BrowserRouter>
  );
}
